// componente para validar el email


// react imports
import { useEffect, useState } from "react";


// components importation
import { LoadingComp } from "../../components/loading-comp/LoadingComp";


// react router dom
import { useNavigate, useParams } from "react-router-dom";
import { urls } from "../../api-urls/api-urls";





export const EmailValidation = () => {

  // GET the language
  const language = localStorage.getItem("language") ?? window.navigator.language.slice(0, 2);

  // GET the useNavigate
  const navigate = useNavigate();

  // state definition
  const [controller, setController] = useState(null);
  const [state, setState] = useState({ isLoading: true, msg: "", great: false });
  const [counter, setCounter] = useState(5);

  // GET the query params
  const { code } = useParams();


  // funcion para consultar la informacion al servidor
  const fetchDataServ = async () => {
    const abortController = new AbortController();

    const END_POINT = `${urls.validEmail}/${code}?language=${language}`;

    setController(abortController);
    try {
      setState((val) => ({ ...val, isLoading: true }));
      const response = await fetch(END_POINT, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        signal: abortController.signal
      });

      const data = await response.json();

      if (response.status === 200) {
        setState((val) => ({ ...val, great: true, msg: data?.msg }));
      } else if (response.status === 404) {
        setState((val) => ({ ...val, great: true, msg: data?.msg }));
      }

      setState((val) => ({ ...val, isLoading: false }));

    } catch (error) {
      console.log(error);
    }
  };


  // useEffect para consultar la informacion al servidor
  useEffect(() => {

    fetchDataServ();

    return () => {
      if (controller) {
        controller.abort();
      }
    };

  }, []);


  // useEffect para el countdount
  useEffect(() => {
    if (state.great) {
      const timer = setInterval(() => {
        if (counter > 0) {
          setCounter(counter - 1);
        } else {
          clearInterval(timer);
          localStorage.setItem("tokUUIDEqup", code);
          navigate("/");
        }
      }, 1000);

      return () => {
        clearInterval(timer);
      };
    }
  }, [counter, state.great]);



  return (
    <div className="conta-valid-email">
      {
        state.isLoading && (<LoadingComp />)
      }
      {
        state.great && (<h4>{state.msg} {counter} segundos</h4>)
      }
    </div>
  );
};